/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router'
import ChatLayout from '@web/src/features/chat/chat-layout/chat-layout'
import { ChatRoomProvider } from '@web/src/features/chat/chat-room-context'

export const Route = createFileRoute('/(auth)/(chat-layout)/chat/$roomId')({
  component: RoomLayout,
})

/**
 * Acquires the Ably channel for this room and keeps it for as long as the room is on
 * screen. Mounting the provider at the route level rather than inside the view means a
 * re-render of the timeline never detaches and reattaches the channel.
 */
function RoomLayout() {
  const { roomId } = Route.useParams()

  return (
    <ChatLayout activeRoomId={roomId}>
      <ChatRoomProvider chatRoomId={roomId}>
        <Outlet />
      </ChatRoomProvider>
    </ChatLayout>
  )
}
